import type { BookingsOverviewStore } from '@/scopes/account/bookings-overview/domain/types'
import { useStore } from 'zustand'
import { bookingsOverviewStore } from './store'

export function useBookingsOverviewStore<T>(selector: (state: BookingsOverviewStore) => T): T {
  return useStore(bookingsOverviewStore, selector)
}
